import { useState, useEffect } from 'react';
import {
  ConnectionTypeEnum,
  PspAccountCurrencyType,
} from '../../hoc/bank-and-psp/types';
import { PspIntegrationItemTypes } from './types';

import cn from './info.module.css';

const getConnectionTypeName = (name: string) => {
  let connectionTypeName: string;

  switch (name) {
    case ConnectionTypeEnum.CSM:
      connectionTypeName = 'CMS';
      break;
    case ConnectionTypeEnum.NO_IBAN:
      connectionTypeName = 'No IBAN';
      break;
    case ConnectionTypeEnum.VIRTUAL_IBAN:
      connectionTypeName = 'Virtual IBANs';
      break;
    case ConnectionTypeEnum.PRIME_VAULT:
      connectionTypeName = 'Prime Vault';
      break;
    default:
      connectionTypeName = name;
      break;
  }

  return connectionTypeName;
};

const PspIntegrationItem = ({
  pspIntegrationPayments,
  paymentTypes,
}: PspIntegrationItemTypes) => {
  const [filteredPaymentTypes, setFilteredPaymentTypes] = useState<string[]>(
    [],
  );

  useEffect(() => {
    if (pspIntegrationPayments && pspIntegrationPayments) {
      const nextPaymentTypes: string[] = [];

      pspIntegrationPayments.paymentsTypes?.forEach((item) => {
        if (paymentTypes?.find((type) => type.paymentType === item)) {
          nextPaymentTypes.push(item);
        }
      });

      setFilteredPaymentTypes(nextPaymentTypes);
    }
  }, [paymentTypes, pspIntegrationPayments]);

  return (
    <div className={cn.paymentTypeWrapper}>
      {pspIntegrationPayments &&
        filteredPaymentTypes.map((item) => {
          let currencies;

          if (
            pspIntegrationPayments.currencyType ===
            PspAccountCurrencyType.SPECIFIC
          ) {
            currencies = pspIntegrationPayments.currencies
              .map((value) => value.currency.name)
              .join(', ');
          } else if (
            pspIntegrationPayments.currencyType === PspAccountCurrencyType.ALL
          ) {
            currencies = 'All currencies';
          } else {
            currencies = 'No available currencies';
          }

          return (
            <div className={cn.paymentTypeItem} key={item}>
              <div className={cn.paymentTypeNameWrapper}>
                <div className={cn.paymentTypeName}>
                  {paymentTypes?.find((type) => type.paymentType === item)
                    ?.name || ''}
                </div>
              </div>
              <div className={cn.connetionTypes}>
                {pspIntegrationPayments.connectionsTypes.map((value) => {
                  let hintText;

                  if (value.connectionType === ConnectionTypeEnum.CSM) {
                    hintText = 'Own IBANs generated by the system are used';
                  } else if (
                    value.connectionType === ConnectionTypeEnum.NO_IBAN
                  ) {
                    hintText =
                      'Top up will be done through a single PSP/EMI account opened with the partner bank. The client should specify his/her internal account in the comment to the payment.';
                  } else {
                    hintText =
                      'For each account an external IBAN will be issued by the partner bank';
                  }

                  return (
                    <div className={cn.connectionTypeWrapper} key={value.id}>
                      <div className={cn.connectionType}>
                        {getConnectionTypeName(value.connectionType)}
                        <div className={cn.connectionTypeHint}>
                          i<div className={cn.hintTooltip}>{hintText}</div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className={cn.paymentTypesCurrencies}>{currencies}</div>
            </div>
          );
        })}
    </div>
  );
};

export default PspIntegrationItem;
